<script setup>
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import { FormSection, FormTextarea } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";

const { t: __ } = useI18n();

const settings = await useForm().post("settings_global_systems_index");

const form = useForm({
    text_instructions: settings.text_instructions,
});

const submit = () => {
    form.post("settings_global_systems_update");
};

const placeholder = `Exemple de Custom pour des construction de maison en bois :\n\nObjectif général :\nGénérer des textes informatifs, inspirants et pédagogiques sur l’univers des maisons en bois, en combinant technicité accessible, esthétisme chaleureux et conscience écologique. Le contenu doit être pertinent pour un large éventail d’articles traitant de la construction bois sous différents angles.\n\nContenu – Fond du message :\n1. Mettre en valeur le bois comme matériau principal\n\t- Présenter ses atouts : durabilité, esthétique, confort thermique, régulation naturelle de l’humidité, faible impact carbone.\n\t- Souligner le lien émotionnel et sensoriel avec la nature.\n2. Approche globale et diversifiée\n\t- Couvrir la construction, la rénovation, l’entretien, les styles architecturaux, les tendances, les techniques.\n\t- Inclure également les aspects réglementaires, régionaux et les usages (résidences principales, secondaires, chalets, maisons de vacances...).\n3. Équilibre entre technique et accessibilité\n\t- Intégrer des données ou éléments techniques clairs (sans jargon) pour crédibiliser le contenu tout en restant compréhensible par le grand public.\n4. Fil conducteur écologique et responsable\n\t- Toujours contextualiser la maison bois dans une démarche durable : éco-construction, économies d’énergie, autonomie, respect de l’environnement, matériaux sains.`;
</script>
<template>
    <div class="divide-y divide-gray-300 dark:divide-gray-800">
        <FormSection @submitted="submit">
            <template #title> {{ __("Custom IA") }} </template>
            <template #description>
                {{ __("Le Custom IA va vous permettre d'ajouter des instructions personnalisées globales pour la génération de vos contenus.") }}
            </template>

            <template #form>
                <div class="sm:col-span-full">
                    <div class="relative">
                        <FormTextarea
                            v-model="form.text_instructions"
                            :rows="25"
                            :placeholder="placeholder"
                            :left-actions="[
                                {
                                    id: 'magic-prompt',
                                },
                            ]"></FormTextarea>
                    </div>
                </div>
            </template>

            <template #actions>
                <div class="flex justify-end items-center">
                    <PrimaryButton :processing="form.processing" :success="form.recentlySuccessful"> {{ __("Sauvegarder") }} </PrimaryButton>
                </div>
            </template>
        </FormSection>
    </div>
</template>
